const DIALOGUE_TASK_ENTRY_KEY = 'icbt-dialogue-task-entry';

export function calendarDayKey(date = new Date()) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function shouldRefreshDailyContext({ hasIncompleteTask, preparedDate, currentDate, forceRefresh = false }) {
  return forceRefresh || !hasIncompleteTask || preparedDate !== currentDate;
}

export function findTaskComponent(components, task) {
  if (!task || task.id == null) return undefined;
  // Vue's v-for refs do not retain list order after history is replaced.
  return (components || []).find(component => component?.cardData?.id != null &&
    String(component.cardData.id) === String(task.id) &&
    component.cardData.item_type === task.item_type);
}

export function markDialogueTaskEntry() {
  window.sessionStorage.setItem(DIALOGUE_TASK_ENTRY_KEY, '1');
}

export function clearDialogueTaskEntry() {
  window.sessionStorage.removeItem(DIALOGUE_TASK_ENTRY_KEY);
}

export function returnFromTask(router) {
  if (window.sessionStorage.getItem(DIALOGUE_TASK_ENTRY_KEY) === '1') {
    clearDialogueTaskEntry();
    router.replace('/layout/dialogue');
    return;
  }
  router.go(-1);
}
